import { BaseResponseDto } from '@/models/dtos/baseReponseDto'
import { TemplateDto } from '@/models/dtos/templateDto'
import axios from 'axios'
import { Endpoints } from './_endpoints'

export abstract class TemplateService {
  static async getProjectTemplates(): Promise<TemplateDto[]> {
    const result = await axios.get<BaseResponseDto<TemplateDto[]>>(Endpoints.template.getProjectTemplates)

    if (!result.data.dto) return []

    return result.data.dto
  }

  static async getAll(): Promise<TemplateDto[]> {
    const result = await axios.get<BaseResponseDto<TemplateDto[]>>(Endpoints.template.getAll)

    if (!result.data.dto) return []

    return result.data.dto
  }
}
